import React, { useState, useEffect } from 'react';
import Avatar from '@mui/material/Avatar';
import PhoneIcon from '@mui/icons-material/Phone';
import { useNavigate} from 'react-router-dom';
import {  toast } from 'react-toastify';
import config from '../Config/Config';

function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
}

function stringAvatar(name) {
    return {
        sx: {
            bgcolor: stringToColor(name),
        },
        children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
    };
}

export default function Profile() {
    const [userData, setUserData] = useState({});
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    // console.log(token);
        useEffect(() => {
            fetch(config.apiUrlprofile,{
            method:'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
              }

        })
        .then(res=> res.json())
        .then(data=> {console.log(data)
        setUserData(data)})

        if(token==null){
            toast('Login to proceed further', {
                position: "top-center",
                autoClose: 2000,
                type: "error",
                theme: "colored",
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                })
            navigate('/login');
        }
        }, [])
        
 
        

    
    

    return (
        <div style={{ color: 'white', marginTop: '150px' }} className='container'>
            <div className="row">
                <div className="col-md-6 offset-md-3 text-center">
                    <div className='d-flex justify-content-center'>
                        <Avatar style={{ height: '200px', width: '200px' }} {...stringAvatar(`${userData.firstname} ${userData.lastname}`)} />
                    </div>
                    <h1 className='display-1 text-muted'>Welcome, {userData.firstname}</h1>
                    <hr/>
                    <h3 className='display-5 text-muted'>{userData.firstname} {userData.lastname}  <i className="fa-regular fa-pen-to-square mx-3"></i></h3>
                    <blockquote className="blockquote mt-3 text-muted">
                        <p><i className="fa-regular fa-envelope"></i> {userData.email}</p>
                        <p><PhoneIcon/> +91-{userData.phone}</p>
                    </blockquote>



                </div>
            </div>

        </div>
    )
}
